module.exports = __webpack_public_path__ + "img/Nature.3387f8a.jpg";